export const REFERRAL_STORAGE_KEY = 'atrium_referral_code';

export function generateReferralUrl(code: string): string {
  const baseUrl = process.env.NEXT_PUBLIC_BASE_URL || 'https://atrium.com';
  return `${baseUrl}/?ref=${encodeURIComponent(code)}`;
}

export function getReferralCodeFromUrl(): string | null {
  if (typeof window === 'undefined') return null;
  
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get('ref');
}

export function saveReferralCodeToStorage(code: string): void {
  if (typeof window === 'undefined') return;
  localStorage.setItem(REFERRAL_STORAGE_KEY, code);
}

export function getReferralCodeFromStorage(): string | null {
  if (typeof window === 'undefined') return null;
  return localStorage.getItem(REFERRAL_STORAGE_KEY);
}

export function clearReferralCodeFromStorage(): void {
  if (typeof window === 'undefined') return;
  localStorage.removeItem(REFERRAL_STORAGE_KEY);
}

export function copyToClipboard(text: string): Promise<boolean> {
  if (typeof navigator === 'undefined' || !navigator.clipboard) {
    // Fallback for older browsers
    const textArea = document.createElement('textarea');
    textArea.value = text;
    document.body.appendChild(textArea);
    textArea.select();
    try {
      document.execCommand('copy');
      document.body.removeChild(textArea);
      return Promise.resolve(true);
    } catch (err) {
      document.body.removeChild(textArea);
      return Promise.resolve(false);
    }
  }
  
  return navigator.clipboard.writeText(text).then(() => true).catch(() => false);
}
